import React from 'react';
import { motion } from 'framer-motion';
export function TopBadge() {
  return <div className="bg-brand-900 text-white py-1.5 px-4 text-center text-xs md:text-sm font-medium tracking-wide sticky top-0 z-50 shadow-md flex items-center justify-center gap-2" data-id="element-397">
      <motion.span animate={{
      scale: [1, 1.2, 1]
    }} transition={{
      repeat: Infinity,
      duration: 2,
      repeatDelay: 1
    }} className="inline-block" data-id="element-398">
        🏆
      </motion.span>
      Sistema N°1 para Estudiantes del Profesorado de EF en Argentina
    </div>;
}